import { IPlugin } from 'shared/mechanics/plugin';
import { IAuthApi, IAuthPlugin, AuthService } from 'shared/mechanics/auth';

const clientId = process.env.REACT_APP_INTEGRATION_YANDEX_AUTH_CLIENT_ID!;
const redirectUrl = `${window.location.origin}/auth/signin`;

export class YandexAuthPlugin implements IPlugin, IAuthPlugin {
	name: string = "Yandex Auth";
	displayName: string = "Yandex";

	init(): void {
		const windowWithYandexAuthCallback = window.opener as WindowWithYandexAuthCallback;
		if (windowWithYandexAuthCallback && windowWithYandexAuthCallback.yandexAuthCallbacks) {
			processAuthResponse(windowWithYandexAuthCallback.yandexAuthCallbacks);
		}
	}

	useAuthentication(): Promise<IAuthApi> {
		const authApi: IAuthApi = {
			signIn: async () => {
				const yandexToken = await resolveYandexToken();

				await AuthService.signInYandex(yandexToken);
			}
		}

		return Promise.resolve<IAuthApi>(authApi);
	}
}


interface WindowWithYandexAuthCallback {
	yandexAuthCallbacks?: YandexAuthCallback;
}
interface YandexAuthCallback {
	onSuccess: (ticket: string) => void;
	onFailed: (reason: string) => void;
}

async function resolveYandexToken(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		const authUrl = `https://oauth.yandex.ru/authorize?response_type=token&client_id=${clientId}&redirect_uri=${redirectUrl}&display=popup`;
		document.open(authUrl, 'Yandex Auth', 'popup');

		(window as WindowWithYandexAuthCallback).yandexAuthCallbacks = {
			onSuccess: (ticket) => resolve(ticket),
			onFailed: (reason) => reject(reason)
		}
	});
}

function processAuthResponse(callbacs: YandexAuthCallback){
	const tokenRegex = /access_token=([^&]+)/.exec(document.location.hash || '');

	if (tokenRegex == null) {
		callbacs.onFailed('No token found');
	}
	else {
		const authToken = tokenRegex[1];
		if (authToken == null) {
			callbacs.onFailed('No token found');
		}
		else {
			callbacs.onSuccess(authToken);
		}
	}

	window.close();
}